import React, { useState, useEffect } from 'react';

import Select from 'react-select';
import styles from './TeamManager.module.scss';
import api from "../../services/api";

const TeamManager = () => {
    const [teams, setTeams] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentTeam, setCurrentTeam] = useState({ id: null, name: '', members: [] });
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const [isEditing, setIsEditing] = useState(false);

    // Загрузка списка команд и пользователей
    useEffect(() => {
        fetchTeams();
        fetchUsers();
    }, []);

    const fetchTeams = async () => {
        try {
            const response = await api.get('/api/teams/');
            setTeams(response.data);
        } catch (error) {
            console.error('Ошибка при загрузке команд:', error);
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await api.get('/users');
            setUsers(response.data.map(user => ({ value: user.id, label: user.name })));
        } catch (error) {
            console.error('Ошибка при загрузке пользователей:', error);
        }
    };

    // Открытие модального окна
    const openModal = (team = { id: null, name: '', members: [] }) => {
        setCurrentTeam({
            ...team,
            members: team.members.map(member => ({ value: member.id, label: member.name }))
        });
        setIsEditing(team.id !== null);
        setIsModalOpen(true);
    };

    // Закрытие модального окна
    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentTeam({ id: null, name: '', members: [] });
        setError('');
    };

    // Обработка изменения полей формы
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentTeam({ ...currentTeam, [name]: value });
    };

    // Обработка выбора участников
    const handleMemberChange = (selectedOptions) => {
        setCurrentTeam({ ...currentTeam, members: selectedOptions });
    };

    // Сохранение команды
    const saveTeam = async () => {
        if (!currentTeam.name.trim()) {
            setError('Название команды не может быть пустым.');
            return;
        }

        const teamData = {
            name: currentTeam.name,
            members: currentTeam.members.map(member => member.value), // Отправляем только ID участников
        };

        try {
            if (isEditing) {
                await api.put(`/api/teams/${currentTeam.id}`, teamData);
            } else {
                await api.post('/api/teams/', teamData);
            }
            fetchTeams();
            closeModal();
        } catch (error) {
            console.error('Ошибка при сохранении команды:', error);
            setError('Не удалось сохранить команду.');
        }
    };

    // Удаление команды
    const deleteTeam = async (id) => {
        try {
            await api.delete(`/api/teams/${id}`);
            setTeams(teams.filter((team) => team.id !== id));
        } catch (error) {
            console.error('Ошибка при удалении команды:', error);
        }
    };

    return (
        <div className={styles.teamManager}>
            <h2>Управление командами</h2>
            <button onClick={() => openModal()} className={styles.addButton}>
                Добавить команду
            </button>

            {/* Список команд */}
            <ul className={styles.teamList}>
                {teams.map((team) => (
                    <li key={team.id} className={styles.teamItem}>
                        <div className={styles.teamContent}>
                            <h3>{team.name}</h3>
                            {team.members && team.members.length > 0 && (
                                <p>
                                    <strong>Участники:</strong> {team.members.map(member => member.name).join(', ')}
                                </p>
                            )}
                        </div>
                        <div className={styles.teamActions}>
                            <button onClick={() => openModal(team)} className={styles.editButton}>
                                ✏️
                            </button>
                            <button onClick={() => deleteTeam(team.id)} className={styles.deleteButton}>
                                🗑️
                            </button>
                        </div>
                    </li>
                ))}
            </ul>

            {/* Модальное окно для добавления/редактирования команды */}
            {isModalOpen && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <h3>{isEditing ? 'Редактировать команду' : 'Добавить команду'}</h3>
                        <form>
                            <div className={styles.formGroup}>
                                <label>Название команды</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={currentTeam.name}
                                    onChange={handleInputChange}
                                    className={styles.inputField}
                                    placeholder="Введите название команды"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Участники</label>
                                <Select
                                    isMulti
                                    options={users}
                                    value={currentTeam.members}
                                    onChange={handleMemberChange}
                                    className={styles.selectField}
                                />
                            </div>
                        </form>
                        {error && <p className={styles.error}>{error}</p>}
                        <div className={styles.modalActions}>
                            <button onClick={saveTeam} className={styles.saveButton}>
                                {isEditing ? 'Сохранить' : 'Добавить'}
                            </button>
                            <button onClick={closeModal} className={styles.cancelButton}>
                                Отмена
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TeamManager;